import { type SettingsTemplate, settingsTemplate } from './template'

export const ENV_KEY = 'prd'

export const prd: SettingsTemplate = {
  ...settingsTemplate,
  isProdDeploy: true,

  ENABLE_METRICS: true,

  // Internal tool - no origin restriction (real protection comes from auth, not CORS)
  API_CORS_ALLOW_ORIGIN: '*',

  COMFYUI_AUTO_SHUTDOWN_IDLE_HOURS: 3,
  COMFYUI_USE_SPOT_INSTANCE: false,
  COMFYUI_SPOT_MAX_PRICE: '',

  // Keep the dormant Playground EC2 path deployed so it can be enabled
  // without recreating models or compute infrastructure.
  DEPLOY_COMFYUI_EC2: false,
  ENABLE_EC2_PLAYGROUND: false
}
